const testimages = {
  preview_large: '/testimage/preview_large.jpg',
  maskbg_01: '/testimage/maskbg_01.png',
  maskbg_02: '/testimage/maskbg_02.png',
  maskbg_03: '/testimage/maskbg_03.png',
  maskbg_04: '/testimage/maskbg_04.png',
  maskbg_05: '/testimage/maskbg_05.png',
  maskbg_06: '/testimage/maskbg_06.png',
  maskbg_07: '/testimage/maskbg_07.png',
  maskbg_08: '/testimage/maskbg_08.png',
  maskbg_09: '/testimage/maskbg_09.png',
  maskbg_10: '/testimage/maskbg_10.png',
  maskbg_11: '/testimage/maskbg_11.png',
  maskbg_12: '/testimage/maskbg_12.png',
  banner_design: '/testimage/banner_design.png',
  banner_design1: '/testimage/banner_design1.png',
  banner1: '/testimage/banner1.png',
  banner2: '/testimage/banner2.png',
  banner3: '/testimage/banner3.png',
  banner4: '/testimage/banner4.png',
  banner5: '/testimage/banner5.png',
  banner6: '/testimage/banner6.png',
  hstyle_01: '/testimage/hstyle_01.png',
  hstyle_02: '/testimage/hstyle_02.png',
  hstyle_03: '/testimage/hstyle_03.png',
  hstyle_04: '/testimage/hstyle_04.png',
  hstyle_05: '/testimage/hstyle_05.png',
  hstyle_06: '/testimage/hstyle_06.png',
  hstyle_07: '/testimage/hstyle_07.png',
  hstyle_08: '/testimage/hstyle_08.png',
  category_01: '/testimage/category_01.png',
  category_02: '/testimage/category_02.png',
  category_03: '/testimage/category_03.png',
  category_04: '/testimage/category_04.png',
  category_05: '/testimage/category_05.png',
  category_06: '/testimage/category_06.png',
  category_07: '/testimage/category_07.png',
  design_ex1: '/testimage/design_ex1.png',
  design_ex2: '/testimage/design_ex2.png',
  design_ex3: '/testimage/design_ex3.png',
  design_ex4: '/testimage/design_ex4.png',
  design_ex5: '/testimage/design_ex5.png',
  design_ex6: '/testimage/design_ex6.png',
  design_ex7: '/testimage/design_ex7.png',
  design_ex8: '/testimage/design_ex8.png',
  design_ex9: '/testimage/design_ex9.png',
  design_ex10: '/testimage/design_ex10.png',
  design_ex11: '/testimage/design_ex11.png',
  design_ex12: '/testimage/design_ex12.png',
  design_ex13: '/testimage/design_ex13.png',
  design_ex14: '/testimage/design_ex14.png',
  design_ex15: '/testimage/design_ex15.png',
  design_ex16: '/testimage/design_ex16.png',
  design_ex17: '/testimage/design_ex17.png',
  design_ex18: '/testimage/design_ex18.png',
  design_ex19: '/testimage/design_ex19.png',
  design_ex20: '/testimage/design_ex20.png',
  design_ex21: '/testimage/design_ex21.png',
  design_ex22: '/testimage/design_ex22.png',
  design_ex23: '/testimage/design_ex23.png',
  design_ex24: '/testimage/design_ex24.png',
  design_ex25: '/testimage/design_ex25.png',
  design_ex26: '/testimage/design_ex26.png',
  design_ex27: '/testimage/design_ex27.png',
  design_ex28: '/testimage/design_ex28.png',
  design_ex29: '/testimage/design_ex29.png',
  design_ex30: '/testimage/design_ex30.png',
  Event_01: '/testimage/Event_01.png',
  guide_01: '/testimage/guide_01.png',
  guide_02: '/testimage/guide_02.png',
  guide_03: '/testimage/guide_03.png',
  guide_04: '/testimage/guide_04.png',
  guide_05: '/testimage/guide_05.png',
  guide_06: '/testimage/guide_06.png',
  guide_07: '/testimage/guide_07.png',
  guide_08: '/testimage/guide_08.png',
  guide_09: '/testimage/guide_09.png',
  guide_10: '/testimage/guide_10.png',
  style_01: '/testimage/style_01.png',
  style_02: '/testimage/style_02.png',
  style_03: '/testimage/style_03.png',
  style_04: '/testimage/style_04.png',
  style_05: '/testimage/style_05.png',
  style_06: '/testimage/style_06.png',
  style_07: '/testimage/style_07.png',
  style_08: '/testimage/style_08.png',
  style_09: '/testimage/style_09.png',
  style_10: '/testimage/style_10.png',
  style_11: '/testimage/style_11.png',
  style_12: '/testimage/style_12.png',
  style_13: '/testimage/style_13.png',
  style_14: '/testimage/style_14.png',
  style_15: '/testimage/style_15.png',
  style_16: '/testimage/style_16.png',
  style_17: '/testimage/style_17.png',
  style_18: '/testimage/style_18.png',
  style_19: '/testimage/style_19.png',
  style_20: '/testimage/style_20.png',
  survey_00: '/testimage/survey_00.png',
  survey_01: '/testimage/survey_01.png',
  test1: '/testimage/test1.png',
  topdesigner: '/testimage/topdesigner.png',
  topdesigner_bg: '/testimage/topdesigner_bg.png',
  trend_01: '/testimage/trend_01.png',
  trend_02: '/testimage/trend_02.png',
  trend_03: '/testimage/trend_03.png',
  trend_04: '/testimage/trend_04.png',
  trend_05: '/testimage/trend_05.png',
  trend_06: '/testimage/trend_06.png',
  trend_banner: '/testimage/trend_banner.png',
  trend_detail1: '/testimage/trend_detail1.png',
  trend_detail2: '/testimage/trend_detail2.png',
  test_profile: '/testimage/test_profile.png',
  test_generate_intro: '/testimage/test_generate_intro.png',
};

export default testimages;
